export const routes = (parentName) => {
  return [
    {
      path: "cooperation",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-Cooperation`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-Cooperation-New`,
          component: () => import("./Upsert.vue"),
        },
        {
          path: ":id",
          name: parentName + "-" + "Cooperation-View",
          component: () => import("./View.vue"),
        },
        {
          path: ":id/edit",
          name: parentName + "-" + "Cooperation-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
